import { MessagePaths, useMessagesTranslation } from '@shared/i18n';
import { SuppliersResources } from '../types/SuppliersResources';

export const useSuppliersTranslation = () => useMessagesTranslation<SuppliersResources>();

export type SuppliersMessageKey = MessagePaths<SuppliersResources>;

export const useSuppliersTFunction = () => useSuppliersTranslation().t;

export type SuppliersTFunction = ReturnType<typeof useSuppliersTFunction>;